export const adminContents = {
    'dari': {
        "List of Admins": "لیست مدیران (ادمین‌ها)",
        "Add Admin": "مدیریت مدیر",
        "Admin Management": "مدیریت مدیر",
        "There are no admins added yet": "تاکنون مدیری اضافه نشده است",
        "Click \"Add Admin\" to create one": "برای ایجاد مدیر بر روی کلید «اضافه کردن مدیر» کلیک نمایید",
        "Personal Details": "اطلاعات شخصی",
        "Email Address": "ایمیل آدرس",
        "personal_details": "اطلاعات شخصی",
        "phone_number" : "شماره تلفون",
        "First Name": "نام",
        "Enter first name": "نام را وارد کنید",
        "Last Name": "نام خانوادگی",
        "Enter last name": "نام خانوادگی را وارد کنید",
        "Official email address": "آدرس ایمیل رسمی",
        "official_email_address": "آدرس ایمیل رسمی",
        "Enter Offcial email address": "آدرس ایمیل رسمی را وارد کنید",
        "Enter phone number": "شماره تلفون را وارد نمایید",
        "Residential Details": "آدرس محل سکونت",
        "residential_details": "آدرس محل سکونت",
        "House number": "شماره خانه",
        "Market/Block number": "شماره بلاک/مارکیت",
        "Floor number": "طبقه",
        "Street name": "نام جاده",
        "Enter street name": "نام جاده را وارد نمایید",
        "City/Town": "شهر/شهرک",
        "Enter City/Town": "شهر/شهرک را وارد کنید",
        "Country": "کشور",
        "Select Country": "کشور را انتخاب کنید",
        "Province(State)": "ولایت (ایالت)",
        "Select Province(State)": "ولایت (ایالت) را انتخاب کنید",
        "Region": "منطقه",
        "Select Region": "منطقه را انتخاب کنید",
        "District": "ناحیه (ولسوالی)",
        "Select District": "ناحیه (ولسوالی) را انتخاب کنید",
        "Uploaded SOP (Standard Operating Procedure)": "رهنمود استندرد عملیاتی را ردر سیستم بارگزاری نمایید",
        "Upload ": "بارگزاری",
        "Or": "یا",
        "Drag & Drop": "بکشید و رها کنید",
        "Good resolution & passport size photo is preferred": "فایل‌های قابل پشتیبانی: فارمت  jpg,png,jpeg  و pdf",
        "Access Module": "طرزالعمل‌های دسترسی",
        "Mark As Super Admin": "علامت گذاری به عنوان مدیر ارشد",
        "Listing Distributor": "تهیه لیست توزیع کننده",
        "Add Distributor": "افزودن توزیع کننده",
        "View Specific Distributor Details": "نمایش اطلاعات خاص در مورد توزیع کننده",
        "Edit Distributor": "تصحیح توزیع کننده",
        "Activate / Deactivate Distributor": "فعال/غیر فعال ساختن توزیع کننده",
        "Master Distributor Transactions": "مبادلات توزیع کننده اصلی",
        "Flagging the Transactions": "نشانی کردن مبادلات",
        "Distributor Management": "مدیریت توزیع کننده",
        "Distributor Transactions": "مبادلات توزیع کننده",
        "Sub Distributor Management": "مدیریت توزیع کننده فرعی",
        "Listing Sub Distributor": "تهیه لیست توزیع کننده فرعی",
        "Add Sub Distributor": "افزودن توزیع کننده فرعی",
        "View Specific Sub Distributor Details": "نمایش اطلاعات خاص در مورد توزیع کننده فرعی",
        "Edit Sub Distributor": "تصحیح توزیع کننده فرعی",
        "Activate / Deactivate Sub Distributor": "فعال/غیر فعال ساختن توزیع کننده فرعی",
        "Sub Distributor Transactions": "مبادلات توزیع کننده فرعی",
        "Agent Management": "مدیریت نمایندگان",
        "Listing Agent": "تهیه لیست نمایندگان",
        "Add Agent": "افزودن نماینده",
        "View Specific Agent Details": "نمایش اطلاعات خاص در مورد نماینده",
        "Edit Agent": "تصحیح نماینده",
        "Activate / Deactivate Agent": "فعال/غیر فعال ساختن نماینده",
        "Agent Transactions": "مبادلات نماینده",
        "Retailer Management": "مدیریت پرچون فروشان",
        "Listing Retailers": "تهیه لیست پرچون فروشان",
        "Add Retailer": "افزودن پرچون فروش",
        "View Specific Retailer": "نمایش اطلاعات خاص در مورد پرچون فروشان",
        "Edit Retailer": "تصحیح پرچون فروش",
        "Activate / Deactivate Retailer": "فعال/غیر فعال ساختن پرچون فروش",
        "Retailer Transactions": "مبادلات پرچون فروشان",
        "Customer Management": "مدیریت مشتریان",
        "Listing Customer": "تهیه لیست مشتری",
        "Add Customer": "افزودن مشتری",
        "View Specific Customer Details": "نمایش معلومات خاص در مورد مشتری",
        "Edit Customer": "تصحیح مشتری",
        "Activate / Deactivate Customer": "فعال/غیر فعال ساختن مشتری",
        "Customer Transactions": "مبادلات متشری",
        "Reversal Request": "درخواست اعاده",
        "Listing Reversal Request": "تهیه لیست درخواست‌های اعاده",
        "View Specific Reversal Request Details": "نمایش اطلاعات خاص در مورد درخواست‌های اعاده",
        "Approve / Reject Request": "تایید/رد درخواست",
        "Services": "خدمات",
        "Do Mobile Recharge": "پرداخت کریدت موبایل",
        "Bundle / Package Activation": "فعال ساختن بسته/پکیج",
        "Breshna Service Utilization": "استفاده از خدمات برشنا",
        "Company Management": "مدیریت شرکت",
        "Listing Company": "تهیه لیست شرکت",
        "View Specific Company Details": "نمایش اطلاعات خاص در مورد شرک",
        "Edit Company": "تصحیح شرکت",
        "MNO Management": "مدیریت اپراتورهای شبکه مخابراتی (موبایل)",
        "Listing MNO": "تهیه لیست اپراتورهای شبکه موبایل",
        "Add MNO": "افزودن اپراتورهای شبکه موبایل",
        "View Specific MNO Details": "نمایش اطلاعات خاص در مورد اپراتورهای شبکه موبایل",
        "Edit MNO": "تصحیح اپراتورهای شبکه موبایل",
        "Add Purchase Amount": "افزودن مبلغ خرید",
        "Add Service Fee": "افزودن هزینه خدمات",
        "Support Ticket": "تکیت پشتیبانی",
        "Listing Support Ticket": "تهیه لیست تکیت پشتیبانی",
        "View Specific Support Ticket Details": "نمایش اطلاعات خاص در مورد تکیت پشتیبانی",
        "Take Action on Support Ticket": "اقدام عملی در زمینه تکیت پشتیبانی",
        "Onboarding Request": "درخواست شروع به کار",
        "Listing All Onboarding Request": "تهیه لیست درخواست‌های شروع به کار",
        "View Specific Onboarding Request Details": "نمایش خاص اطلاعات درخواست شروع به کار",
        "Edit the Onboarding Request": "تصحیح درخواست شروع به کار",
        "Approve / Reject the Onboarding Request": "تایید/رد درخواست شروع به کار",
        "Modification Request": "درخواست اِعمال تغییرات",
        "Listing All Modification Request": "تهیه لیست تمام درخواست‌های اِعمال تغییرات",
        "View Specific Modification Request Details": "نمایش اطلاعات خاص در مورد درخواست‌های اِعمال تغییرات",
        "Edit the Modification Request": "تصحیح درخواست اعمال تغییرات",
        "Approve / Reject the Modification Request": "تایید/رد درخواست اِعمال تغییرات",
        "Dashboard": "داشبورد",
        "Total Number of Users on the Platform": "تعداد مجموعی کاربران در پلتفورم",
        "Total Number of Receivables": "تعداد مجموعی اقلام قابل دریافت",
        "Total Number of Payables": "تعداد مجموعی اقلام قابل پرداخت",
        "Recharge Report": "گزارش اضافه کردن کریدیت (ریچارج)",
        "MNO Wise Recharge Sales Trend": "روند فروش کریدیت بر اساس اپراتور شبکه موبایل",
        "MNO Wise Package Sales Trend": "روند فروش پکیچ بر اساس اپراتور شبکه موبایل",
        "ETop Up Stock Sales Trend": "روند فروش سهام ETop Up",
        "Geographical MNO Recharge Sales": "فروش کریدیت اپراتورهای شبکه موبایل بر اساس محدوده جغرافیایی",
        "Geographical MNO Package Activation Sales": "فروش پکیج اپراتورهای شبکه موبایل بر اساس محدوده جغرافیایی",
        "Geographical ETop Up Stock Sales": "فروش سهام ETop Up براساس محدوده جغرافیایی",
        "Merchant Wise MNO Recharge Sales": "فروش کریدیت اپراتورهای شبکه موبایل بر اساس فروشنده",
        "Merchant Wise MNO Package Activation Sales": "فروش پکیج اپراتورهای شبکه موبایل بر اساس فروشنده",
        "Merchant Wise ETop Up Stock Sales": "فروش سهام ETop Up براساس فروشنده",
        "Customer MNO Recharge Sales": "فروش کریدیت اپراتور شبکه موبایل بر اساس مشتری",
        "Customer MNO Package Activation Sales": "فروش پکیج اپراتور شبکه موبایل بر اساس مشتری",
        "Customer MNO ETop Up Stock Sales": "فروش سهام ETop Up براساس مشتری",
        "MNO Available Balance": "بیلانس موجودی اپراتور شبکه موبایل",
        "MNO Target Vs Achievement": "هدف اپراتور شبکه موبایل در مقایسه با دستاورد",
        "CVM Dashboard": "داشبورد ارتقای ارزش مشتری (CVM)",
        "Active / Inactive / Dormant Users Status": "حالت‌های فعال سازی/غیر فعال/توقف یافته کاربران",
        "Target vs Achievement": "هدف در مقایسه با دستاورد",
        "Top 3 Merchant Wise ETop Up Stock Transfer Ranking": "رتبه بندی انتقال سهام ETop Up بر اساس 3 فروشنده برتر",
        "Count of Users": "تعداد کاربران",
        "System Transactional Performance Ratio": "نسبت عملکرد مبادلات سیستم",
        "Reports": "گزارش‌ها",
        "ETop Up Recharge Report": "گزارش تغذیه مجدد (ریچارج) Etop Up",
        "Bundle Activation Report": "گزارش فعال سازی بسته",
        "Unsuccessful Transaction Report": "گزارش مبادلات ناموفق",
        "MNO's Service Fee Earned Report": "گزارش مصارف دریافت شده خدمات  توسط اپراتورهای شبکه موبایل",
        "MNO Wise Sales Trend Report": "گزارش زوند فروشات بر اساس اپراتورهای شبکه موبایل",
        "Stock Transfer Report": "گزارش سفارش خرید سهام Etop Up",
        "Wallet Transfer Report": "گزارش انتقال والت (بکسک پول)",
        "MNO Wise ETop Up Available Balance Report": "گزارش موجودی بیلانس ETop Up بر اساس اپراتور شبکه موبایل",
        "MNO Wise Bundle Balance Activation Report": "گزارش بیلانس فعال سازی بسته بر اساس اپراتور شبکه موبایل",
        "MNO Wise ETop Up Purchase Report": "گزارش خرید ETop Up بر اساس اپراتور شبکه موبایل",
        "MNO Wise Bundle Balance Purchase Report": "گزارش خرید بیلانس بسته بر اساس اپراتور شبکه موبایل",
        "Merchant / Customer eTop Up Wallet Balance Report": "گزارش بیلانس والت ETop Up بر اساس فروشنده/مشتری",
        "ZoodPay Profitablity Report": "گزارش سودآوری زودپی",
        "Recharge Reversal Report": "گزارش اعاده بازپرداخت",
        "ETop Up Stock / Digital Wallet Report of Admin / Super Admin": "گزارش موجودی ETop Up / والت دیجیتال مدیر/مدیر ارشد",
        "CVM Report": "گزارش توزیع کمیشن CVM",
        "On Target Achievement of MNO Report": "گزارش دستیابی به هدف اپراتور شبکه موبایل",
        "Geographical Sales Report": "گزارش فروشات بر اساس ساحات جغرافیایی",
        "Stock Account Statement": "صورتحساب حساب موجودی (سهام)",
        "Money Accounts Statement": "صورتحساب حساب‌های پولی",
        "Upfront Purchased Report": "گزارش پیش خریدها",
        "Upfront Sales Report": "گزارش پیش فروش‌ها",
        "Bulk Amount Transfer": "انتقال مبلغ کلان",
        "Capability to do Bulk Recharge": "ظرفیت انجام تغذیه کلان",
        "Wallet / Fund Transfer": "انتقال بودجه/والت",
        "Capability to do Bulk Bundle Activation": "ظرفیت فعال سازی بسته کلان",
        "Career Section Management": "مدیریت بخش وظیفوی",
        "Add Data Related to Career": "افزودن اطلاعات مربوط به وظیفه",
        "Remove Data Related to Career": "حذف اطلاعات مربوط به وظیفه",
        "View all Job Application": "نمایش تمام درخواستی‌های کاری",
        "Blog Management": "مدیریت بلاگ",
        "Add Blog": "افزودن بلاگ",
        "Remove Blog": "حذف بلاگ",
        "View the Blog": "نمایش بلاگ مذکور",
        "View Access": "نمایش دسترسی",
        "ETop Up ": "ETop Up",
        "Digital Wallet": "والت دیجیتل",
        "Invalid phone number": "شماره تلفون فاقد اعتبار",
        "Abu": "ابو",
        "Salim": "سالم (سلیم)",
        "22/Yard": "22/یارد",
        "Aleem Kulfa": "علیم کولفا",
        "Kabib": "کبیب",
        "Afganisthan": "افغانستان",
        "Kunduz": "کندوز",
        "Filename.pdf": "نام فایل.pdf",
        "2ab/8": "2ab/8",
        "Albania": "آلبانیا",
        "Algeria": "الجزایر",
        "Angola": "آنگولا",
        "One Time Password (OTP)": "رمز عبور یک بار مصرف",
        "We have sent a code to habibizood123@zoodpay.com": "کُد مورد نظر به ایمیل habibizood123@zoodpay.com ارسال شد",
        "OTP has been sent to habibizood123@zoodpay.com": "رمز عبور یک بار مصرف به ایمیل habibizood123@zoodpay.com ارسال شد",
        "Filter": "فیلتر",
        "Export": "وارد کردن فایل",
        "User Code": "کُد کاربر",
        "User Name": "نام کاربری",
        "Created Date": "تاریخ ایجاد",
        "Created date": "تاریخ ایجاد",
        "Phone Number": "شماره تلفون",
        "Phone number": "شماره تلفون",
        "User Location": "موقعیت کاربر",
        "Last Logged In": "آخرین ورود",
        "Status": "وضعیت",
        "Actions": "اقدامات",
        "ADM854": "ADM854",
        "Aaaban Aabdar": "آبان آبدار",
        "aabanaabdar@zoodpay.com": "aabanaabdar@zoodpay.com",
        "Kuduz,Kabul,Afghan": "کندوز، کابل، افغان",
        "Inactive": "غیر فعال",
        "Active": "فعال",
        "List exported successfully": "لیست با موفقیت وارد شد",
        "Filter By": "فیلتر بر اساس",
        "Date Range": "محدوده تاریخی",
        "Start date": "تاریخ آغاز",
        "End date": "تاریخ ختم",
        "Clear All": "حذف کامل",
        "Apply": "انجام دستور",
        "All": "تمام موارد",
        "No results found": "نتیجه‌ای دریافت نشد",
        "Try adjusting your filter's or search criteria": "معیار جستجو یا فیلتر خود را تغییر دهید",
        "Confirm Deactivation": "تایید غیر فعال سازی",
        "This action will revoke access to all features and tasks": "این اقدام دسترسی به تمام مشخصات و وظایف را لغو خواهد کرد",
        "Reset Password": "تجدید رمز عبور",
        "Reset Pin": "تجدید PIN",
        "Reset": "تنظیم دوباره",
        "Cancel": "ابطال",
        "Would you like to proceed with resetting the PIN for {{admin_name}} ({{admin_user_code}})?": "آیا می‌خواهید PIN حساب {{admin_name}} {{admin_user_code}} را مجدداً تنظیم نمایید؟",
        "Would you like to proceed with resetting the password for {{admin_name}} ({{admin_user_code}})?": "آیا می‌خواهید رمز عبور {{admin_name}} {{admin_user_code}} را مجدداً تنظیم نمایید؟",
        "This action will grant access to features and tasks": "این اقدام دسترسی به مشخصات و وظایف را فراهم خواهد کرد",
        "Confirm Activation": "تایید فعال سازی",
        "Admin activated successfully": "ادمین با موفقیت فعال شد",
        "Admin deactivated successfully": "ادمین با موفقیت غیر فعال شد",
        "Reason": "دلیل",
        "Enter the reason": "دلیل خود را وارد کنید",
        "Subject: ZoodPay Account is Activated!": "موضوع: حساب زودپی فعال شد!",
        "We are pleased to inform you that your account has been activated! You can now access all the designated features and perform associated tasks.": "با خرسندی به اطلاع می‌رسانیم که حساب شما فعال شد! اکنون می‌توانید به تمام مشخصات تعیین شده دسترسی پیدا کرده و وظایف مربوطه را انجام دهید.",
        "Subject: ZoodPay Account is Deactivated.": "موضوع: حساب زودپی غیر فعال شد.",
        "Your account has been deactivated. You no longer have access to the designated features or the ability to perform associated tasks.": "حساب شما غیر فعال شد! اکنون به مشخصات تعیین شده دسترسی نداشته و از انجام وظایف مربوطه برخوردار نخواهید بود.",
        "Reason for Deactivation:": "دلیل غیر فعال ساختن حساب:",
        "Click “Add Admin” to create one": "برای ایجاد مدیر بر روی کلید «اضافه کردن مدیر» کلیک نمایید",
    },
    'pashto': {
        "List of Admins": "د اډمېنانو لېست",
        "Add Admin": "د مدیر اضافه کول",
        "Admin Management": "د مدیر (اډمېن) مدیریت",
        "There are no admins added yet": "تر اوسه مدیر نه دی اضافه شوی",
        "Click \"Add Admin\" to create one": "د مدیر د جوړولو لپاره پر «مدیر اضافه کول» کلېک وکړئ",
        "Personal Details": "شخصي جزئیات",
        "personal_details": "شخصي جزئیات",
        "Email Address": "برېښنالیک داخل کړئ",
        "phone_number":"د ټېلېفون شمېره",
        "First Name": "نوم",
        "Enter first name": "نوم ولیکئ",
        "Last Name": "تخلص",
        "Enter last name": "تخلص ولیکئ",
        "Official email address": "رسمي برېښنالیک",
        "official_email_address": "رسمي برېښنالیک",
        "Enter Offcial email address": "رسمي برېښنالیک ولیکئ",
        "Enter phone number": "د ټېلېفون شمېره ولیکئ",
        "Residential Details": "د استوګنې د ځای جزئیات",
        "residential_details": "د استوګنې د ځای جزئیات",
        "House number": "د کور شمېره",
        "Market/Block number": "د مارکېټ/بازار شمېره",
        "Floor number": "د پوړ شمېر",
        "Street name": "د سړک نوم",
        "Enter street name": "د سړک نوم ولیکئ",
        "City/Town": "ښارګوټی",
        "Enter City/Town": "د ښارګوټي نوم ولیکئ",
        "Country": "هېواد",
        "Select Country": "هېواد وټاکئ",
        "Province(State)": "ولایت",
        "Select Province(State)": "ولایت وټاکئ",
        "Region": "ساحه/زون",
        "Select Region": "ساحه/زون وټاکئ",
        "District": "ناحیه (ولسوالي)",
        "Select District": "ناحیه (ولسوالي) وټاکئ",
        "Uploaded SOP (Standard Operating Procedure)": "معیاري عملیاتي کړنلاره پورته کړئ",
        "Upload ": "سیستم ته پورته کول",
        "Or": "یا",
        "Drag & Drop": "را کش کړئ او خوشي کړئ",
        "Good resolution & passport size photo is preferred": "د  jpg,png,jpeg او pdf بڼې لرونکي فایلونه د  استعمال وړ دي",
        "Access Module": "د لاسرسي لارښود",
        "Mark As Super Admin": "د لوی مدیر په توګه نښاني کول",
        "Listing Distributor": "د توزیع کوونکو لېست کول",
        "Add Distributor": "د توزیع کوونکو اضافه کول",
        "View Specific Distributor Details": "د توزیع کوونکي په اړه د مشخصو جزئیاتو ښودل",
        "Edit Distributor": "د توزیع کوونکي سمول",
        "Activate / Deactivate Distributor": "د توزیع کوونکي فعالول/غیر فعالول",
        "Master Distributor Transactions": "د اصلي توزیع کوونکي مبادلات",
        "Flagging the Transactions": "د مبادلاتو نښاني کول",
        "Distributor Management": "د توزیع کوونکي مدیریت",
        "Distributor Transactions": "د توزېع کوونکي مبادلات",
        "Sub Distributor Management": "د فرعي توزېع کوونکي مدیریت",
        "Listing Sub Distributor": "د فرعي توزېع کوونکي لېست کول",
        "Add Sub Distributor": "د فرعي توزېع کوونکي اضافه کول",
        "View Specific Sub Distributor Details": "د فرعي توزېع کوونکي په اړه د ځانګړو جزئیاتو ښوودنه",
        "Edit Sub Distributor": "د فرعي توزېع کوونکي سمول",
        "Activate / Deactivate Sub Distributor": "د فرعي توزېع کوونکي فعالول/غیر فعالول",
        "Sub Distributor Transactions": "د فرعي توزېع کوونکي مبادلات",
        "Agent Management": "د استازي مدیریت",
        "Listing Agent": "د استازي لېست کول",
        "Add Agent": "د استازي اضافه کول",
        "View Specific Agent Details": "د استازي په اړه د ځانګړو جزئیاتو ښوودنه",
        "Edit Agent": "د استازي سمول",
        "Activate / Deactivate Agent": "د استازي فعالول/غیر فعالول",
        "Agent Transactions": "د استازي مبادلات",
        "Retailer Management": "د پرچون پلورونکو مدیریت",
        "Listing Retailers": "د پرچون پلورونکو لېست کول",
        "Add Retailer": "د پرچون پلورونکو اضافه کول",
        "View Specific Retailer": "د پرچون پلورونکو په اړه د ځانګړو جزئیاتو ښوودنه",
        "Edit Retailer": "د پرچون پلورونکو سمول",
        "Activate / Deactivate Retailer": "د پرچون پلورونکو فعالول/غیر فعالول",
        "Retailer Transactions": "د پرچون پلورونکو مبادل",
        "Customer Management": "د پېرودونکو مدیریت",
        "Listing Customer": "د پېرودونکو لېست کول",
        "Add Customer": "د پېرودونکو اضافه کول",
        "View Specific Customer Details": "د پېرودونکو په اړه د ځانګړو جزئیاتو ښوودنه",
        "Edit Customer": "د پېرودونکي سمول",
        "Activate / Deactivate Customer": "د پېرودونکو فعالول/غیر فعالول",
        "Customer Transactions": "د پېرودونکي مبادلات",
        "Reversal Request": "د اعادې غوښتنه",
        "Listing Reversal Request": "د اعادې د غوښتنې لېست کول",
        "View Specific Reversal Request Details": "د اعادې د غوښتنو په اړه د ځانګړو جزئیاتو ښوودنه",
        "Approve/Reject Request": "د غوښتنې تایید/رد",
        "Services": "خدمات",
        "Do Mobile Recharge": "مبایل ته کرېډېټ اچول",
        "Bundle / Package Activation": "د بستې/کڅوړې فعالول",
        "Breshna Service Utilization": "د برېښنا د خدماتو کارول",
        "Company Management": "د شرکت مدیریت",
        "Listing Company": "د شرکت لېست جوړول",
        "View Specific Company Details": "د شرکت په اړه د ځانګړو جزئیاتو ښوودنه",
        "Edit Company": "د شرکت سمول",
        "MNO Management": "د مخابراتی شبکې د آپرېټرانو مدیریت",
        "Listing MNO": "د مخابراتی شبکې د آپرېټرانو لېست کول",
        "Add MNO": "د مخابراتي شبکې د آپرېټرانو اضافه کول",
        "View Specific MNO Details": "د مخابراتي شبکې د آپرېټرانو په اړه د ځانګړو جزئیاتو ښوودنه",
        "Edit MNO": "د مخابراتي شبکې د آپرېټرانو سمول",
        "Add Purchase Amount": "د پېرودلو د مبلغ اضافه کول",
        "Add Service Fee": "د خدماتو د فیس اضافه کول",
        "Support Ticket": "حمایتي ټکټ",
        "Listing Support Ticket": "د حمایتي ټکټ لېست کول",
        "View Specific Support Ticket Details": "د حمایتي ټکټ په اړه د ځانګړو جزئیاتو ښوودنه",
        "Take Action on Support Ticket": "د حمایتي ټکټ په اړه عملي اقدام",
        "Onboarding Request": "د کار د پیلولو لپاره غوښتنه",
        "Listing All Onboarding Request": "د کار د پیلولو لپاره د ټولو غوښتنو لېست کول",
        "View Specific Onboarding Request Details": "د کار د پیلولو لپاره د غوښتل شوو جزئیاتو ښوودنه",
        "Edit the Onboarding Request": "د کار د پیلولو لپاره د غوښتنې سمول",
        "Approve / Reject the Onboarding Request": "د کار د پیلولو د غوښتنې تایید/رد",
        "Modification Request": "د بدلون راوستلو غوښتنه",
        "Listing All Modification Request": "د بدلون راوستلو د ټولو غوښتنو لېست کول",
        "View Specific Modification Request Details": "د بدلون راوستلو لپاره د غوښتل شوو ځانګړو جزئیاتو ښوودنه",
        "Edit the Modification Request": "د بدلون راوستلو د غوښتنې سمول",
        "Approve / Reject the Modification Request": "د بدلون راوستلو د غوښتنې تایید/رد",
        "Dashboard": "ډشبورډ",
        "Total Number of Users on the Platform": "په پلټفارم کې د کاروونکو ټولټال شمېر",
        "Total Number of Receivables": "د ترلاسه کېدونکو توکو ټولټال شمېر",
        "Total Number of Payables": "د ورکړې وړ توکو ټولټال شمېر",
        "Recharge Report": "د کرېډېټ ډېرولو راپور",
        "MNO Wise Recharge Sales Trend": "د مخابراتي شبکې د اپرېټر پر اساس د کرېډېټ ډېرولو د خرڅلاو پروسه",
        "MNO Wise Package Sales Trend": "د مخابراتي شبکې د اپرېټر پر اساس د کڅوړې (پکېچ) د خرڅلاو پروسه",
        "ETop Up Stock Sales Trend": "د ETop Up د ونډو د خرڅلاو پروسه",
        "Geographical MNO Recharge Sales": "د جغرافیایي محدودې پر اساس د مخابراتي شبکې د اپرېټرانو د کرېډېټ ډېرولو خرڅلاو",
        "Geographical MNO Package Activation Sales": "د جغرافیایي محدودې پر اساس د مخابراتي شبکې د اپرېټرانو د کڅوړې (پکېج)  خرڅلاو",
        "Geographical ETop Up Stock Sales": "د جغرافیايي محدودې پر اساس د ETop Up د ونډو خرڅلاو",
        "Merchant Wise MNO Recharge Sales": "د پلورونکي پر اساس  د مخابراتي شبکې د اپرېټرانو د کرېډېټ خرڅلاو",
        "Merchant Wise MNO Package Activation Sales": "د پلورونکي پر اساس  د مخابراتي شبکې د اپرېټرانو د کڅوړې (کرېډېټ) خرڅلاو",
        "Merchant Wise ETop Up Stock Sales": "د پلورونکي پر اساس د ETop Up د ونډو  خرڅلاو",
        "Customer MNO Recharge Sales": "د پېرودونکي پر اساس د مخابراتی شبکې د اپرېټرانو د کرېډېټ خرڅلاو",
        "Customer MNO Package Activation Sales": "د پېرودونکي پر اساس د مخابراتی شبکې د اپرېټرانو د کڅوړې (پکېج) خرڅلاو",
        "Customer MNO ETop Up Stock Sales": "د پېرودونکي پر اساس د ETop Up د ونډو  خرڅلاو",
        "MNO Available Balance": "د مخابراتي شبکې د اپرېټرانو د موجودۍ بیلانس",
        "MNO Target Vs Achievement": "د مخابراتي شبکې د آپرېټرانو موخه د لاسته راوړنې په مقابل کې",
        "CVM Dashboard": "د پېرودونکي د ارزښت لوړولو ډشبورد",
        "Active / Inactive / Dormant Users Status": "د کاروونکو د فعالولو/غیر فعالولو/درولو حالتونه",
        "Target vs Achievement": "موخه د لاسته راوړنې په مقابل کې",
        "Top 3 Merchant Wise ETop Up Stock Transfer Ranking": "د درېیو غوره پلورونکو پر اساس د ETop Up د انتقال د رتبه بندۍ ونډه",
        "Count of Users": "د کاروونکو شمېر",
        "System Transactional Performance Ratio": "د سیستم د مبادلاتو د کړنې نسبت",
        "Reports": "راپورونه",
        "ETop Up Recharge Report": "د Etop Up کرېډېټ ډېرولو راپور",
        "Bundle Activation Report": "د بستې/کڅوړې فعالولو راپور",
        "Unsuccessful Transaction Report": "د نا بریالیو مبادلاتو راپور",
        "MNO's Service Fee Earned Report": "د مخابراتي شبکې د آپرېټرانو لخوا د ترلاسه شوو خدماتو د لګښتونو راپور",
        "MNO Wise Sales Trend Report": "د مخابراتي شبکې د آپرېټر انو پر اساس د خرڅلاو د پروسې راپور",
        "Stock Transfer Report": "د Etop Up د ونډو د پېرلو راپور",
        "Wallet Transfer Report": "د بټوې د انتقال راپور",
        "MNO Wise ETop Up Available Balance Report": "د مخابراتي شبکې د اپرېټر پر اساس د Etop Up د بیلانس د موجودۍ راپور",
        "MNO Wise Bundle Balance Activation Report": "د مخابراتي شبکې د اپرېټرانو پر اساس د بستې د فعالولو د بیلانس راپور",
        "MNO Wise ETop Up Purchase Report": "د مخابراتي شبکې د اپرېټر  پر اساس د Etop Up د پېرلو راپور",
        "MNO Wise Bundle Balance Purchase Report": "د مخابراتي شبکې د آپرېټور پر اساس د بستې د بیلانس د پېرلو راپور",
        "Merchant / Customer eTop Up Wallet Balance Report": "د پلورونکي/پېرودونکي پر اساس د Etop Up د بټوې (والېټ) د بیلانس راپور",
        "ZoodPay Profitablity Report": "د زود پې د ګټې کولو راپور",
        "Recharge Reversal Report": "د کرېډټ ډېرولو د اعادې راپور",
        "ETop Up Stock / Digital Wallet Report of Admin / Super Admin": "د مدیر/سر مدیر د Etop Up د موجودۍ/دیجیتلي بټوې راپور",
        "CVM Report": "د CVM راپور",
        "On Target Achievement of MNO Report": "د مخابراتي شبکې د اپرېټور د ترلاسه کېدونکې موخې راپور",
        "Geographical Sales Report": "د جغرافیايي ساحو پر اسس د پلور راپور",
        "Stock Account Statement": "د موجودي صورت حساب",
        "Money Accounts Statement": "د پیسو د حسابونو صورت حساب",
        "Upfront Purchased Report": "له مخکې د پېرل شویو راپور",
        "Upfront Sales Report": "له مخکې د پلورل شویو راپور",
        "Bulk Amount Transfer": "د لوی مقدار مبلغ انتقال",
        "Capability to do Bulk Recharge": "د لوی مقدار بیا اضافه کولو (ریچارج) ظرفیت",
        "Wallet / Fund Transfer": "د بټوې/بودیجې انتقال",
        "Capability to do Bulk Bundle Activation": "د لوی مقدار بستې د فعالولو ظرفیت",
        "Career Section Management": "د کاري/مسلکي برخې مدیریت",
        "Add Data Related to Career": "په کاري برخه/مسلک پورې د اړوندې ډېټا اضافه کول",
        "Remove Data Related to Career": "په کاري برخه/مسلک پورې د اړوندې ډېټا لرې کول",
        "View all Job Application": "د ټولو کاري غوښتنو ښوودنه",
        "Blog Management": "د بلاګ مدیریت",
        "Add Blog": "د بلاګ اضافه کول",
        "Remove Blog": "د بلاګ لرې کول",
        "View the Blog": "د بلاګ ښوودنه",
        "View Access": "د لاسرسي ښوودنه",
        "ETop Up ": "ETop Up",
        "Digital Wallet": "دیجتلي بټوه (والېټ)",
        "Invalid phone number": "ناسمه ټېلېفون شمېره",
        "Abu": "ابو",
        "Salim": "سالم/سلیم",
        "22/Yard": "۲۲/یارډ",
        "Aleem Kulfa": "علیم کولفا",
        "Kabib": "کبیب",
        "Afganisthan": "افغانستان",
        "Kunduz": "کندوز",
        "Filename.pdf": "د فایل نوم. Pdf",
        "2ab/8": "2ab/8",
        "Albania": "البانیا",
        "Algeria": "الجزایر",
        "Angola": "آنګولا",
        "One Time Password (OTP)": "د یو ځل کارېدو وړ پسورډ",
        "We have sent a code to habibizood123@zoodpay.com": "کود habibizood123@zoodpay.com برېښنالیک ته ولېږل شو",
        "OTP has been sent to habibizood123@zoodpay.com": "یو ځل کارېدو وړ پسورډ habibizood123@zoodpay.com برېښنالیک ته ولېږل شو",
        "Filter": "فېلتر",
        "Export": "د فایل واردول",
        "User Code": "د کاروونکي کود",
        "User Name": "د کاروونکي نوم",
        "Created Date": "د جوړېدو نېټه",
        "Created date": "د جوړېدو نېټه",
        "Phone Number": "د ټېلېفون شمېره",
        "Phone number": "د ټېلېفون شمېره",
        "User Location": "د کاروونکي موقعیت",
        "Last Logged In": "وروستی ځل د ننه کېدل",
        "Status": "حالت",
        "Actions": "اقدامات",
        "ADM854": "ADM854",
        "Aaaban Aabdar": "آبان آبدار",
        "aabanaabdar@zoodpay.com": "aabanaabdar@zoodpay.com",
        "Kuduz,Kabul,Afghan": "کندوز، کابل، افغان",
        "Inactive": "غیر فعال",
        "Active": "فعال",
        "List exported successfully": "لېست په بریالیتوب سره دننه کړل شو",
        "Filter By": "فېلتر د ... پر اساس",
        "Date Range": "د نېټې محدوده",
        "Start date": "د پیل نېټه",
        "End date": "د پای نېټه",
        "Clear All": "په بشپړ ډول پاکول",
        "Apply": "د کار اجرا کول",
        "All": "ټول موارد",
        "No results found": "پایله پیدا نه شوه",
        "Try adjusting your filter's or search criteria": "د خپل فېلتر بدلول یا د معیار لپاره پلټنه",
        "Confirm Deactivation": "د غیر فعالولو تاییدي",
        "This action will revoke access to all features and tasks": "دغه اقدام به ټولو مشخصاتو او دندو ته لاسرسی لغوه کړي",
        "Reset Password": "د پسورډ نوي/تازه کول",
        "Reset Pin": "PIN له سره کول/نوي کول",
        "Reset": "له سره تنظیمول",
        "Cancel": "کنسل/باطلول",
        "Would you like to proceed with resetting the PIN for {{admin_name}} {{admin_user_code}}?": "آیا غواړئ د عبدل د حساب {{admin_name}} {{admin_user_code}} د PIN له سره بیا تنظیم کړئ؟",
        "Would you like to proceed with resetting the password for {{admin_name}} {{admin_user_code}}?": "آیا غواړئ د {{admin_name}} {{admin_user_code}} پسورډ له سره بیا تنظیم کړئ؟",
        "This action will grant access to features and tasks": "دغه اقدام به مشخصاتو او دندو ته لاسرسی برابر کړی شي",
        "Confirm Activation": "د فعالولو تاییدي",
        "Admin activated successfully": "اډمېن په بریالیتوب سره فعال شو",
        "Admin deactivated successfully": "اډمېن په بریالیتوب سره غیر فعال شو",
        "Reason": "دلیل",
        "Enter the reason": "خپل دلیل ولیکئ",
        "Subject: ZoodPay Account is Activated!": "موضوع: زود پې حساب فعال شو!",
        "We are pleased to inform you that your account has been activated! You can now access all the designated features and perform associated tasks.": "په خوښۍ سره خبر درکوو چې ستاسو حساب فعال شو! اوس کولی شئ ټولو ټاکل شوو مشخصاتو ته لاسرسی ولرئ او اړوندې دندې اجرا کړئ",
        "Subject: ZoodPay Account is Deactivated.": "موضوع: زود پې حساب غیر فعال شو",
        "Your account has been deactivated. You no longer have access to the designated features or the ability to perform associated tasks.": "ستاسو حساب غیر فعال شو! اوس تاسو نه شی کولئ ټاکل شوو مشخصاتو ته لاسرسی ولرئ او اړوندې دندې نه شئ اجرا کولئ",
        "Reason for Deactivation:": "د حساب د غیر فعالولو دلیل:",
        "Click “Add Admin” to create one": "د مدیر د جوړولو لپاره پر «مدیر اضافه کول» کلېک وکړئ",
    },
    'uzbeki': {
        "List of Admins": "مدیرلر رویخطی (ادمینلر)",
        "Add Admin": "مدیرنی قوشیش",
        "Admin Management": "مدیر باشقرووی",
        "There are no admins added yet": "هنوزگچه قنده‌ی مدیر قوشیلمه‌گن",
        "Click \"Add Admin\" to create one": "مدیر ایجاد ایتیش اوچون «قوشیش» تکمه‌سینی باسینگ",
        "Personal Details": "شخصی معلومات",
        "personal_details": "شخصی معلومات",
        "Email Address": "ایمیل آدرسینگیزنی کیریتینگ",
        "phone_number":"تلفون رقمی",
        "First Name": "آت",
        "Enter first name": "آتینگیزنی یازینگ",
        "Last Name": "عایله‌وی آت",
        "Enter last name": "عایله‌وی آتینگیزنی یازینگ",
        "Official email address": "رسمی ایمیل آدرس",
        "official_email_address": "رسمی ایمیل آدرس",
        "Enter Offcial email address": "رسمی ایمیل آدرسنی یازینگ",
        "Enter phone number": "تیلفون رقمینگیزنی یازینگ",
        "Residential Details": "یشش محللینگیز آدرسی",
        "residential_details": "یشش محللینگیز آدرسی",
        " House number": "اوی رقمی",
        "Market/Block number": "بلاک/ مارکیت شماره‌سی",
        "Floor number": "قَوت/ طبقه",
        "Street name": "جاده نینگ آتی",
        "Enter street name": "جاده‌نینگ آتینی یازینگ",
        "City/Town": "شهر/ شهرچه",
        "Enter City/Town": "شهر/شهرچه‌نی یازینگ",
        "Country": "اولکه",
        "Select Country": "اولکه‌نی تنلنگ",
        "Province(State)": "ولایت (ایالت)",
        "Select Province(State)": "ولایت (ایالت)نی تنلنگ",
        "Region": "منطقه",
        "Select Region": "منطقه‌نی تنلنگ",
        "District": "ناحیه (اولسواللیک)",
        "Select District": "ناحیه‌ (اولسواللیک)نی تنلنگ",
        "Uploaded SOP (Standard Operating Procedure)": "عملیاتی استندرد رهنمالیگینی سیستمگه یوکلنگ",
        "Upload ": "یوکلنگ",
        "Or": "یا",
        "Drag & Drop": "چیقاریب آلیب تشلنگ",
        "Good resolution & passport size photo is preferred": "قوللب قووتلنه دیگن فایللر:  فارمت  jpg,png,jpeg  و pdf",
        "Access Module": "کیریش طرزالعمللر",
        "Mark As Super Admin": "کته مدیر صفتیده بیلگیلش",
        "Listing Distributor": "توزیع قیلوچی رویخطینی تیارلش",
        "Add Distributor": "توزیع قیلوچینی قوشیش",
        "View Specific Distributor Details": "توزیع قیلوچی باره‌سیده انیق معلومات نی کورسه‌تیش",
        "Edit Distributor": "توزیع قیلوچینی توغریلش",
        "Activate / Deactivate Distributor": "توزیع قیلوچینی فعال/ غیر فعال ایتیش",
        "Master Distributor Transactions": "اساسي توزیع قیلوچی المشیووی",
        "Flagging the Transactions": "المشیوونی انیقلش",
        "Distributor Management": "توزیع قیلوچی باشقریش",
        "Distributor Transactions": "توزیع قیلوچی المشیووی",
        "Sub Distributor Management": "فرعی توزیع قیلوچی باشقریش",
        "Listing Sub Distributor": "فرعی توزیع قیلوچی رویخطینی تیارلش",
        "Add Sub Distributor": "فرعی توزیع قیلوچینی قوشیش",
        "View Specific Sub Distributor Details": "فرعی توزیع قیلوچی حقیده انیق معلماتنی کورسه‌تیش",
        "Edit Sub Distributor": "فرعی توزیع قیلوچی نی توغریلش",
        "Activate / Deactivate Sub Distributor": "فرعی توزیع قیلوچی نی فعال/ و غیر فعال ایتیش",
        "Sub Distributor Transactions": "فرعی توزیع قیلوچی المشووی",
        "Agent Management": "نماینده‌لر باشقرووی",
        "Listing Agent": "نماینده‌لر رویخطینی تیارلش",
        "Add Agent": "نماینده‌نی قوشیش",
        "View Specific Agent Details": "نماینده‌ حقیده انیق معلومات",
        "Edit Agent": "نماینده‌نی توغریلیش",
        "Activate / Deactivate Agent": "نماینده‌نی فعال/ غیر فعال ایتیش",
        "Agent Transactions": "نماینده المشووی",
        "Retailer Management": "چکنه (پرچون) ساتوچیلر باشقرووی",
        "Listing Retailers": "چکنه (پرچون) ساتوچیلر رویخطینی تیارلش",
        "Add Retailer": "چکنه (پرچون) ساتوچینی قوشیش",
        "View Specific Retailer": "چکنه (پرچون) ساتوچی حقیده انیق معلوماتنی کورسه‌تیش",
        "Edit Retailer": "چکنه‌ (پرچون) ساتوچینی توغریلش",
        "Activate / Deactivate Retailer": "چکنه (پرچون) ساتوچینی فعال/ غیر فعال ایتیش",
        "Retailer Transactions": "چکینه (پرچون) ساتوچیلر المشیووی",
        "Customer Management": "مشتریلر باشقرووی",
        "Listing Customer": "مشتریلر رویخطینی تیارلش",
        "Add Customer": "مشترینی قوشیش",
        "View Specific Customer Details": "مشتری حقیده انیق معلوماتنی کورسه‌تیش",
        "Edit Customer": "مشترینی توغریلش",
        "Activate / Deactivate Customer": "مشترینی فعال/ غیر فعال ایتیش",
        "Customer Transactions": "مشتری المشیووی",
        "Reversal Request": "درخواست نی تیکلش",
        "Listing Reversal Request": "درخواست نی تیکلش رویخطینی تیارلش",
        "View Specific Reversal Request Details": "درخواست نی تیکلش باره سیده انیق معلومات کورستیش",
        "Approve / Reject Request": "ایستکنی تصدیق/رد ایتیش",
        "Services": "خذمتلر",
        "Do Mobile Recharge": "مبایلگه کریدت تشلش",
        "Bundle / Package Activation": "بسته/پکیج نی فعال ایتیش",
        "Breshna Service Utilization": "برشنا خذمتلریدن فایده‌له‌نیش",
        "Company Management": "شرکت باشقرووی",
        "Listing Company": "شرکت رویخطینی تیارلش",
        "View Specific Company Details": "شرکت حقیده انیق معلومات نی کورستیش",
        "Edit Company": "شرکت نی توغریلش",
        "MNO Management": "مخابراتی ترماق (مبایل) اپراتورلر باشقرووی",
        "Listing MNO": "مبایل ترماغی اپراتورلر رویخطینی تیارلش",
        "Add MNO": "مبایل ترماقلری اپراتورلری رویخطینی تیارلش",
        "View Specific MNO Details": "مبایل ترماقلری اپراتورلری حقیده انیق معلومات کورسه‌تیش",
        "Edit MNO": "مبایل ترماغی اپراتورلرینی توغریلش",
        "Add Purchase Amount": "ساتیب آلیش مبلغ نی قوشیش",
        "Add Service Fee": "خذمتلر خرجتینی قوشیش",
        "Support Ticket": "قوللش تکیت",
        "Listing Support Ticket": "قوللش  تکیت رویخطینی تیارلش",
        "View Specific Support Ticket Details": "قوللش تکیت باره‌سیده انیق معلومات کورسه‌تیش",
        "Take Action on Support Ticket": "قوللش تکیت باره‌سیده عملی چاره",
        "Onboarding Request": "ایش باشلش ایستگی",
        "Listing All Onboarding Request": "ایشگه باشلش ایستکلری رویخطینی تیارلش",
        "View Specific Onboarding Request Details": "ایشگه باشلش ایستگی باره‌سیده انیق معلومات",
        "Edit the Onboarding Request": "ایشگه باشلش ایستگینی توغریلش",
        "Approve / Reject the Onboarding Request": "ایشگه باشلش ایستگی تصدیق/رد",
        "Modification Request": "اوزگرتیریشلرنی قوللشنی سوره‌ش",
        "Listing All Modification Request": "اوزگرتیریشنی قوولش ایستکلری برچه رویخطینی تیارلش",
        "View Specific Modification Request Details": "اوزگرتیریشنی قوولش ایستکلری حقیده انیق معلومات کورسه‌تیش",
        "Edit the Modification Request": "اوزگرتیریشنی قوولش ایستگینی توغیریلش",
        "Approve/Reject the Modification Request": "اوزگرتیریشنی قوولش ایستگینی تصدیق/رد",
        "Dashboard": "داشبورد",
        "Total Number of Users on the Platform": "پلتفورده‌گی فایده‌لنوچیلرنینگ عمومی سانی",
        "Total Number of Receivables": "قبول قیلینیشی ممکن بولگن نرسه‌لر نینگ عمومي سانی",
        "Total Number of Payables": "تولنه دیگن نرسه‌لرنینگ عمومی سانی",
        "Recharge Report": "قیته آزیقه‌لنتیریش گزارشی (ریچارج)",
        "MNO Wise Recharge Sales Trend": "مبایل ترماغی اپراتور اساسیده کریدیت ساتیش جریانی",
        "MNO Wise Package Sales Trend": "مبایل ترماغی اپراتور اساسیده پکیج نی ساتیش جریانی",
        "ETop Up Stock Sales Trend": "سهام‌نی ساتیش جریانی ETop Up",
        "Geographical MNO Recharge Sales": "مبایل علاقه‌ اوپرا‌تورلری نینگ جغرافیایی حدودگه قره‌ب کریدیت ساتیش",
        "Geographical MNO Package Activation Sales": "جغرافیا حدود بوییچه‌ مبایل علاقه‌ اوپرا‌تورلری نینگ پکیج ساتیش",
        "Geographical ETop Up Stock Sales": "ETop Up سهاملرنی جغرافیا حدودگه قره‌ب ساتیش",
        "Merchant Wise MNO Recharge Sales": "مبایل علاقه‌ اوپرا‌تورلری نینگ ساتووچیگه اساسلنگن کریدیت ساتیش",
        "Merchant Wise MNO Package Activation Sales": "ساتووچی اساسیده مبایل علاقه‌ اوپرا‌تورلری نینگ پکیج ساتیش",
        "Merchant Wise ETop Up Stock Sales": "ساتوچی اساسیده ETop Up سهامنی ساتیش",
        "Customer MNO Recharge Sales": "مشتری اساسیده مبایل علاقه‌ اوپیرا‌توری کریدیتینی ساتیش",
        "Customer MNO Package Activation Sales": "مبایل ترماق اوپرا‌توری پکیج مشتری اساسیده ساتیش",
        "Customer MNO ETop Up Stock Sales": "مشتری تامانیدن ETop Up سهام‌لرینی ساتیش",
        "MNO Available Balance": "مبایل ترماغی اپراتور موجود بلانسی",
        "MNO Target Vs Achievement": "مبایل ترماغی اپراتور مقصدی نینگ یوتوغی",
        "CVM Dashboard": "مشتری قیمتینی آشیریش داشبوردی (CVM)",
        "Activate / Inactive / Dormant Users Status": "فایده‌لنووچیلر نینگ یاقیلگن/اوچیریلگن/توخته‌تیلگن حالتلری",
        "Target Vs Achievement": "دستاوردگه کوره سالیشتیریش هدفی",
        "Top 3 Merchant Wise ETop Up Stock Transfer Ranking": "اینگ یخشی ۳ ته ساتووچیگه اساسلنگن ETop Up سهام انتقال رتبه بندلیگی",
        "Count of Users": "فایده‌لنوچیلر",
        "System Transactional Performance Ratio": "تیزیم المشینوولری نینگ ایشلش عملکری",
        "Reports": "گزارشلر",
        "ETop Up Recharge Report": "قَیته آزیقلنتیریش گزارشی (ریچارد) Etop Up",
        "Bundle Activation Report": "بسته نی فعال ایتیش گزارشی",
        "Unsuccessful Transaction Report": "نا موفق المشیووی گزارشی",
        "MNO's Service Fee Earned Report": "مبایل ترماغی اپراتورلر تامانیدن خذمت کورسه‌تیلگن مصرفلر گزارشی",
        "MNO Wise Sales Trend Report": "مبایل ترماقلری اپراتور اساسیده‌گی ساتیش جریانی گزارشی",
        "Stock Transfer Report": "سهام ساتیب آلیش اوچون بویورتمه گزارشی Etop Up",
        "Wallet Transfer Report": "والت نی ییتکزیش گزارشی (بکسک پول)",
        "MNO Wise ETop Up Available Balance Report": "مبایل ترماغی اپراتوری اساسیده Etop Up موجود بلانس گزارشی",
        "MNO Wise Bundle Balance Activation Report": "مبایل ترماغی اپراتوری اساسیده بسته بیلانس ساتیب آلیش گزارشی",
        "MNO Wise ETop Up Purchase Report": "مبایل اپراتور اساسیده  Etop Up  ساتیب آلیش گزارشی",
        "MNO Wise Bundle Balance Purchase Report": "مبایل ترماغی اپراتور اساسیده بسته بلانس ساتیب آلیش گزارشی",
        "Merchant / Customer eTop Up Wallet Balance Report": "ساتیب آلوچی اساسیده  ETop Up والت بیلانس گزارشی",
        "ZoodPay Profitablity Report": "زودپی سودآورلیک گزارشی",
        "Recharge Reversal Report": "قیته تولش گزارشی",
        "ETop Up Stock / Digital Wallet Report of Admin / Super Admin": "مدیر/ارشد مدیر دیجیتال ولات Etop Up موجودی گزارشی",
        "CVM Report": "راپور CVM",
        "On Target Achievement of MNO Report": "مبایل ترماغی اپراتور مقصدیگه ایریشیش گزارشی",
        "Geographical Sales Report": "جغرافیا حدود اساسیده ساتیش گزارشی",
        "Stock Account Statement": "موجود حساب صورت حسابی (سهام)",
        "Money Accounts Statement": "پولی حسابلر صورت حسابی",
        "Upfront Purchased Report": "آلدین ساتیب آلینگنلر گزارشی",
        "Upfront Sales Report": "آلدین ساتیلگنلر گزارشی",
        "Bulk Amount Transfer": "کته مقدارده پول ییتکزیش",
        "Capability to do Bulk Recharge": "کته آزیقه لنتیریش قابلیت",
        "Wallet / Fund Transfer": "بودجه /ولت ییتکزیش",
        "Capability to do Bulk Bundle Activation": "کته بسته نی فعال ایتیش قابلیتی",
        "Career Section Management": "وظیفوی بولیم مدیریتی",
        "Add Data Related to Career": "وظیفه گه تیگیشلی معلوماتنی قوشیش",
        "Remove Data Related to Career": "وظیفه گه تیگیشلی معلوماتنی حذف ایتیش",
        "View all Job Application": "برچه ایشلر درخواستینی کورستیش",
        "Blog Management": "بلاگ مدیرتی",
        "Add Blog": "بلاگ نی قوشیش",
        "Remove Blog": "بلاگ نی حذف ایتیش",
        "View the Blog": "مذکور بلاگ نی کورستیش",
        "View Access": "ایریشیش نی کورستیش",
        "ETop Up ": "ETop Up",
        "Digital Wallet": "دیجیتل والت",
        "Invalid phone number": "اعتباری بولمه گن شماره تیلفون",
        "Abu": "ابو",
        "Salim": "سالم (سلیم)",
        "22/Yard": "22/یارد",
        "Aleem Kulfa": "علیم کولفا",
        "Kabib": "کبیب",
        "Afganisthan": "افغانستان",
        "Kunduz": "قندوز",
        "Filename.pdf": "فایل آتی.pdf",
        "2ab/8": "2ab/8",
        "Albania": "آلبانیا",
        "Algeria": "الجزایر",
        "Angola": "آنگولا",
        "One Time Password (OTP)": "بیر بار مصرف اوتیش رمز",
        "We have sent a code to habibizood123@zoodpay.com": "ایمیل اوچون نظرده توتیلگن کد habibizood123@zoodpay.com یوباریلدی",
        "OTP has been sent to habibizood123@zoodpay.com": "ایمیل گه بیر مرته مصرف بوله دیگن رمز  habibizood123@zoodpay.com  یوباریلدی",
        "Filter": "فیلتر",
        "Export": "فایل نی کیریتیش",
        "User Code": "فایده‌لنوچی کدی",
        "User Name": "فایده‌لنوچی آتی",
        "Created Date": "ایجاد بولگنی تاریخی",
        "Created date": "ایجاد بولگنی تاریخی",
        "Phone Number": "تلفون رقمی",
        "Phone number": "تلفون رقمی",
        "User Location": "فایده‌لنوچی موقعیتی",
        "Last Logged In": "سونگی کیریش",
        "Status": "وضعیت",
        "Actions": "چاره تدبیر",
        "ADM854": "ADM854",
        "Aaaban Aabdar": "آبان آبدار",
        "aabanaabdar@zoodpay.com": "aabanaabdar@zoodpay.com",
        "Kuduz,Kabul,Afghan": "قندوز، کابل، افغان",
        "Inactive": "غیر فال",
        "Active": "فعال",
        "List exported successfully": "رویخط موفقیت بیلن کیریتیلدی",
        "Filter By": "فیلتر اساسیده",
        "Date Range": "تاریخی محدوده",
        "Start date": "باشله نیش تاریخی",
        "End date": "یکونی تاریخ",
        "Clear All": "بوتونله ی حذف",
        "Apply": "دستور بجریلیشی",
        "All": "برچه موردلر",
        "No results found": "نتیجه تاپیلمه‌دی",
        "Try adjusting your filter's or search criteria": "قیدیریش معیاری یا فیلترینگیزنی اوزگرتیرینگ",
        "This action will revoke access to all features and tasks": "بو چاره تدبیر برچه مشخصات و وظیفه لرگه ایریشیشنی بیکار قیلیشی ممکن",
        "Reset Password": "اوتیش رزم نی ینگیلش",
        "Reset Pin": "ینگیPIN",
        "Reset": "ینگیدن تنظیم",
        "Cancel": "بیکار قیلیندی",
        "This action will grant access to features and tasks": "بو چاره تدبیر مشخصات و  وظیفه گه ایریشیشنی یره تیشی ممکن",
        "Confirm Activation": "د فعالولو تاییدي",
        "Admin activated successfully": "ادمین موفقیت بیلن فعال بولدی",
        "Admin deactivated successfully": "ادمین موفقیت بیلن غیر فعال بولدی",
        "Confirm Deactivation": "فعال بولمسلیکنی تصدیقلش",
        "Reason": "دلیل",
        "Enter the reason": "دلیلینگیزنی یازینگ",
        "Subject: ZoodPay Account is Activated!": "موضوع: زودپی حساب فعال بولدی!",
        "We are pleased to inform you that your account has been activated! You can now access all the designated features and perform associated tasks.": "سیز نینگ حسابینگیز فعاللشتیریلگنلیگینی ممنونیت بیلن معلوم قیله‌میز! ایندی سیز برچه‌ بیلگیلنگن و تیگیشلی وظیفه‌لرنی بجریشینگیز ممکن.",
        "Subject: ZoodPay Account is Deactivated.": "موضوع: زودپی حساب غیر فعال بولدی",
        "Your account has been deactivated. You no longer have access to the designated features or the ability to perform associated tasks.": "پشتویحسابینگیز اوچیریلدی! اېندی سیز کورسه‌تیلگن مشخصاتلرگه کیره آلمه‌یسیز و تیگیشلی وظیفه‌لرنی بجره آلمه‌یسیز.",
        "Reason for Deactivation:": "حسابنی غیر فعال ایتیش دلیلی",
        "Would you like to proceed with resetting the PIN for {{admin_name}} {{admin_user_code}}?": "آیا عبدل PIN حسابی {{admin_name}} {{admin_user_code}} ینگی دن تنظیم بولیشنی ایسته‌یسیزمی؟",
        "Would you like to proceed with resetting the password for {{admin_name}} {{admin_user_code}}?": "آیا اوتیش رمز  {{admin_name}} {{admin_user_code}} قیته دن تنظیم بولیشنی ایسته‌ی سیزمی؟",
        "Click “Add Admin” to create one": "مدیر ایجاد ایتیش اوچون «قوشیش» تکمه‌سینی باسینگ",
    }
}